<template>
  <v-menu v-model="menu" :close-on-content-click="false" top>
    <template v-slot:activator="{ on }">
      <v-chip
        class="block-chip"
        style="height: 100%"
        label
        link
        exact
        color="#46c93a33"
        v-on="on"
      >
        <v-row
          style="height: 42px; width: 100%;"
          align="center"
          justify="center"
          no-gutters
        >
          <v-icon color="#46c93a" x-small left>fa-plus</v-icon>
          <span class="chip-title">Ajouter</span>
        </v-row>
      </v-chip>
    </template>
    <v-card>
      <v-card-text>
        <IngredientAdder
          :id="id"
          :ingredients="ingredients"
          :intermediate-product="intermediateProduct"
          @submit="menu = false"
        ></IngredientAdder>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import IngredientAdder from "./IngredientAdder";
export default {
  name: "IngredientTabItemAdder",
  components: {
    IngredientAdder
  },
  props: {
    id: {
      required: true
    },
    ingredients: {
      type: Array,
      required: true
    },
    intermediateProduct: {
      default: null
    }
  },
  data() {
    return {
      menu: false
    };
  }
};
</script>

<style scoped lang="scss">
.chip-title {
  color: #46c93a;
  font-size: 0.9rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.08em;
  line-height: 1rem;
}
</style>
